import type { ProspectResponse } from "../../../../../types/api";
import { prospectName, carryOverCount } from "./mergeFields";

interface PreviewStepProps {
  survivor: ProspectResponse;
  losers: ProspectResponse[];
}

/**
 * Step 3 — carry-over preview. Summarizes what will move onto the survivor
 * (note counts derived from each source's `noteCount`) and states plainly how
 * many profiles will be retired. This is the last screen before the
 * irreversible confirm.
 */
export const PreviewStep = ({ survivor, losers }: PreviewStepProps) => {
  const movingNotes = losers.reduce((sum, p) => sum + carryOverCount(p), 0);
  const retiredCount = losers.length;

  return (
    <div className="merge-modal__preview" data-testid="merge-preview">
      <p className="merge-modal__hint">
        Review before merging. This cannot be undone.
      </p>

      <div className="merge-modal__preview-survivor">
        <span className="merge-modal__preview-label">Surviving profile</span>
        <span className="merge-modal__preview-survivor-name">
          {prospectName(survivor)}
        </span>
      </div>

      <ul className="merge-modal__preview-counts">
        <li>
          <strong data-testid="preview-notes-count">{movingNotes}</strong> note
          {movingNotes !== 1 ? "s" : ""} will move onto the surviving profile
        </li>
        <li>
          All videos, documents, scouting data, tags, teams, and events from the
          other profiles will be combined
        </li>
      </ul>

      <p className="merge-modal__preview-retire" data-testid="preview-retire-note">
        <strong>
          {retiredCount} profile{retiredCount !== 1 ? "s" : ""} will be retired
        </strong>{" "}
        and removed from your players list:
      </p>
      <ul className="merge-modal__preview-losers">
        {losers.map((p) => (
          <li key={p.id}>{prospectName(p)}</li>
        ))}
      </ul>
    </div>
  );
};
